<app-base-dialog [sizeClass]="'size-35'" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header [title]="title()" [sluitbaar]="true" (sluiten)="dialogRef.close()"></app-dialog-header>
	</ng-template>

	@if (!enabled()) {
		<div class="warning">
			<app-icon name="alert" size="xxlarge" color="warning-1"></app-icon>
			<div class="warning-text">
				Je kunt de gedeelde pagina niet openen of als favoriet opslaan omdat je geen toegang hebt tot het desbetreffende overzicht. Neem
				contact op met je applicatiebeheerder om de juiste rechten aan te vragen.
			</div>
		</div>
	}

	<div class="inhoud">
		<div class="kopblok">
			<div class="kopregel">
				<span class="naam">{{ gedeeldePaginaPersoonGroep().naam }}</span>
				<span class="datum">{{ gedeeldePaginaPersoonGroep().verzonden | date: "dd-MM-yyyy" }}</span>
			</div>
			@if (gedeeldePaginaPersoonGroep().type === GedeeldePaginaPersoonMode.OUTBOX) {
				<p class="aan">Aan: {{ gedeeldePaginaPersoonGroep().namen.join(", ") }}</p>
			}
		</div>

		<p class="bericht">{{ bericht() }}</p>

		<app-pagina-samenvatting [url]="url()" [titel]="gedeeldePaginaPersoonGroep().dashboard"></app-pagina-samenvatting>

		<app-button buttonType="text" icon="toevoegen" [autoHeight]="true" [enabled]="enabled()" (clickit)="opslaanAlsFavoriet()"
			>Opslaan als favoriet</app-button
		>
	</div>

	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Sluiten</app-button>
		<app-button [enabled]="enabled()" (clickit)="openOverzicht()">Dashboard bekijken</app-button>
	</ng-template>
</app-base-dialog>
